import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styleGrid from '../../blocks/grid/style.pcss';
import style from './style';
import classNames from 'classnames/bind';
import { add, edit } from '../tasks/actions';
import config from 'config';

import ModalDialog from '../modal-dialog';
import { show as showModalDialog } from '../modal-dialog/actions';
import { LOGO_TYPE } from '../tasks/types';
import { LINE_TYPE_MNEMONIC, SELECT_SPECIAL } from '../../pages/home/types';
import { setVisible } from '../progress-bar/actions';

const classnames = classNames.bind(style);
const GENERATE_PDF_URL = `${config.serverUrl}/api/generatePdf`;
const EVENTS_LIMIT = 500;

@connect((state) => ({
    eventsCount  : state.checked.eventsCount,
    isSearchEvent: state.tournaments.isSearchEvent,
    sports       : state.sports.items,
    tournaments  : state.tournaments.items,
    select       : state.select,
    checked      : state.checked
}))
class Buttons extends Component {

    state = {
        isGenerateDisable: false
    };

    static displayName = '[block] buttons';

    static propTypes = {
        eventsCount  : PropTypes.number,
        select       : PropTypes.object,
        dispatch     : PropTypes.func,
        checked      : PropTypes.object,
        isSearchEvent: PropTypes.bool,
        sports       : PropTypes.array,
        tournaments  : PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array
        ])
    };

    generateLineRequest = (url, select, localId) => {
        fetch(url, {
            method: 'GET'
        }).then((response) => {
            response.json().then((data) => {
                this.props.dispatch(setVisible({
                    localId,
                    isVisible: false
                }));

                this.props.dispatch(edit({
                    title: `${select.logo.value} — ${select.line.value} — ${select.period.value} — ${select.special.value}`,
                    id   : data.id,
                    localId
                }));

                this.setState({ isGenerateDisable: false });
            })
                .catch(() => {
                    this.setState({ isGenerateDisable: false });
                });
        })
            .catch(() => {
                this.setState({ isGenerateDisable: false });
            });
    };

    createLine = (e) => {
        e.preventDefault();

        const { select, checked, eventsCount, sports, tournaments, isSearchEvent } = this.props;
        let sportIds = [];
        let tournamentIds = [];
        const keyProperties = isSearchEvent ? 'eventIds' : 'tournament';
        const allGameId = sports.map((sport) => sport.gameId.toString()); // сохраняем все id отсортированных пользователем видов спорта для дальнейшей сортирки

        allGameId.forEach((item) => {
            if(checked.items[item]) {
                if(Array.isArray(checked.items[item])) {
                    const allTournaments = isSearchEvent ? tournaments : tournaments[item];
                    // сохраняем все id осортированных пользователем турниров для дальнейшей сортирки
                    const allIdTournament = allTournaments.map((tournament) => tournament._id);

                    // добавляем выбранные турнир в массив
                    tournamentIds.push(checked.items[item]);

                    // сортируем турниры внутри спорта
                    return tournamentIds.forEach((tournament) => tournament.sort((a, b) => allIdTournament.indexOf(a) - allIdTournament.indexOf(b)));
                }

                return sportIds.push(item)
            }
        });

        if(eventsCount > 0 && eventsCount <= EVENTS_LIMIT) {
            this.setState({ isGenerateDisable: true });

            const sport = sportIds.length ? `&sport=${sportIds.join(',')}` : '';
            const tournament = tournamentIds.length ? `&${keyProperties}=${tournamentIds.join(',')}` : '';
            const type = `&type=${select.line.value === LINE_TYPE_MNEMONIC.FULL ? 'full' : 'main'}`;
            const logo = `&logo=${LOGO_TYPE[select.logo.value]}`;
            const popular = `&popular=${select.special.value === SELECT_SPECIAL.POPULAR}`;
            const period = `&period=${select.period.date}`;
            const orientation = `&orientation=${select.line.value === LINE_TYPE_MNEMONIC.MAIN_PORTRAIT ? 'portrait' : 'landscape'}`;
            const url = `${GENERATE_PDF_URL}?dl=pl&${type}${sport}${tournament}${logo}${orientation}${popular}${period}`;

            const localId = new Date().getTime();

            this.props.dispatch(add({
                title: `${select.logo.value} — ${select.line.value} — ${select.period.value} — ${select.special.value}`,
                id   : null,
                localId
            }));

            this.props.dispatch(setVisible({
                localId,
                isVisible: true
            }));

            this.generateLineRequest(url, select, localId);
        } else {
            this.setState({ isGenerateDisable: false });
            let msg = 'Не выбран ни один вид спорта/чемпионат';

            if(eventsCount > EVENTS_LIMIT) {
                msg = `Количество событий превышает лимит. Допускается выбор до ${EVENTS_LIMIT} событий.`;
            }

            showModalDialog(this.props.dispatch, msg, 'Внимание');
        }
    };

    render() {
        return (
            <div className={styleGrid['grid__buttons']}>
                <div className={styleGrid['grid__buttons-left']} />
                <div className={styleGrid['grid__buttons-right']}>
                    <button disabled={this.state.isGenerateDisable} onClick={this.createLine} className={style['create-line']} type="button">Сформировать линию</button>
                    <div className={style['selected']}>Выбрано событий:&nbsp;
                        <span
                            className={classnames('selected__amount', {
                                selected__amount_green: !!this.props.eventsCount //eslint-disable-line camelcase
                            })}
                        >
                            {this.props.eventsCount}
                        </span>
                    </div>
                </div>

                <ModalDialog />
            </div>
        )
    }

}

export default Buttons;



// WEBPACK FOOTER //
// ./src/blocks/buttons/index.js